import { render, staticRenderFns } from "./ChangePermit.vue?vue&type=template&id=5716c503"
import script from "./ChangePermit.vue?vue&type=script&lang=js"
export * from "./ChangePermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports